<template>
  <div>

    <nav class="navbar customNavbar">
      <div class="navbar-brand">
        <a v-on:click="root()">
          <img class="logoClass" src="/static/logo.png">
        </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item customNavbarItem" v-on:click="root()">Inicio</a>
        <a class="navbar-item customNavbarItem" v-on:click="about()">Nosotros</a>
        <a class="navbar-item customNavbarItem" v-on:click="products()">Productos</a>
        <a class="navbar-item customNavbarItem" v-on:click="news()">Noticias</a>
        <a class="navbar-item customNavbarItem" v-on:click="contact()">Contacto</a>
        <a class="navbar-item customNavbarItem" v-if="isLogged" v-on:click="logout()">Cerrar Sesión</a>
        <a class="navbar-item customNavbarItem" v-else v-on:click="login()">Iniciar Sesión</a>
      </div>
    </nav>

    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <carousel :autoplay="true" :perPage="1" :navigationEnabled="true" :loop="true">
            <slide v-for="highlight of highlights" :key="highlight.id">
              <h3 class="sliderTitle">{{highlight.title}}</h3>
              <a v-on:click="productDetail(highlight.link)">
                <img class="sliderImg" :src="multimediaBase+highlight.imagePath" :alt="highlight.name" width="500px" height="200px"/>
              </a>
            </slide>
          </carousel>
        </div>
      </div>
    </section>
    <section class="section">

      <br/>
      <hr style="margin-bottom: 0">
      <br/>

      <div class="container">
        <h2 class="title is-3">Buscador</h2>
        <div class="columns">
          <div class="column"></div>
          <div class="column is-6">
            <form>
              <div class="field has-addons">
                <p class="control is-expanded">
                  <input v-model="search_landing" v-validate="'required'" data-vv-as="search" :class="{'input': true, 'is-danger': errors.has('search_landing') }" type="text" name="search_landing" />
                  <span v-show="errors.has('search_landing')" class="help is-danger">{{ errors.first('search_landing') }}</span>
                </p>
                <div class="control">
                  <button class="button customButton" v-on:click="search()">Buscar</button>
                </div>
              </div>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>

      <br/>
      <hr class="newsDivider">
      <br/>

      <div class="container">
        <h2 class="title is-3">Noticias</h2>
        <div class="tile is-ancestor">
          <div class="tile is-parent" v-for="newsItem of latestNews" :key="newsItem.id">
            <article class="tile is-child box">
              <p class="title is-4">{{newsItem.title}}</p>
              <div class="content">
                <img v-if="newsItem.firstImage != null" :src="multimediaBase+newsItem.firstImage" width="150px" align="left" style="margin-right: 20px">
                <p class="newsInfo"><i>{{newsItem.dateStr}}</i> - {{newsItem.message}}</p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="logoClass" src="/static/logo.png">
            <p class="footerInfo">
              Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la
              tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de
              asesoría técnica profesional, capacitación y productos efectivos a precios justos.
            </p>
          </div>
          <div class="column is-4">
            <a href="https://www.google.com/maps/@14.5945742,-90.5766572,17.25z" >
              <img width="400px" height="300px" class="mapInfo" src="/static/images/newmap.png"/>
            </a>
          </div>
          <div class="column">
            <p class="footerContact">
              2da calle 18-87 sector B-1<br/>
              Ciudad San Cristóbal zona 8 de Mixco<br/>
              Guatemala<br/>
              (502) 2478-1179 / 80 / 82 / 99<br/><br/>
              <a href="https://wa.me/50240251346">
                <img width="20px" height="20px" src="/static/images/whatsapp-icon.png" class="iconImage">
                WhatsApp: (502) 4025 - 1346
              </a><br/><br/>
              <a href="mailto:ventas@hipromeasa.com">
                <img width="20px" height="20px" src="/static/images/mail-icon.png" class="iconImage">
                E-Mail: ventas@hipromeasa.com
              </a><br/><br/>
              <a href="https://www.facebook.com/hipromeasa">
                <img width="20px" height="20px" src="/static/images/facebook-icon.png" class="iconImage">
                Estamos en Facebook
              </a>
            </p>
          </div>
        </div>
        <div class="content has-text-centered">
          <p class="footerLast">2025 - Todos los derechos reservados</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ApiClient from '@/api/ApiClient.js'
export default {
  name: 'landing',
  data () {
    return {
      isLogged: localStorage.getItem('email') !== null,
      highlights: [],
      latestNews: [],
      search_landing: '',
      multimediaBase: '/multimedia/'
    }
  },
  methods: {
    root: function () {
      this.$router.push('/')
    },
    logout: function () {
      localStorage.removeItem('email')
      localStorage.removeItem('token')
      this.isLogged = false
      this.$router.push('/')
    },
    about: function () {
      this.$router.push('/about')
    },
    products: function () {
      this.$router.push('/products')
    },
    news: function () {
      this.$router.push('/news')
    },
    contact: function () {
      this.$router.push('/contact')
    },
    login: function () {
      this.$router.push('/login')
    },
    productDetail: function (link) {
      this.$router.push(link)
    },
    getHighlights () {
      ApiClient.highlights().then(response => {
        if (response.data.success) {
          this.highlights = response.data.highlights
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getLatestNews () {
      ApiClient.latestNews().then(response => {
        if (response.data.success) {
          this.latestNews = response.data.news
        }
      }).catch(error => {
        ApiClient.onError(error)
      })
    },
    getData () {
      this.getHighlights()
      this.getLatestNews()
    },
    search () {
      console.log(this.search_landing)
      this.$router.push('/search/' + this.search_landing)
    }

  },
  created () {
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logoClass {
    height: 60px;
    width: 220px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .newsInfo {
    text-align: left;
  }
  .footerInfo {
    margin-left: 60px;
    margin-right:60px;
    text-align: center;
    font-size: small;
  }
  .footerContact {
    text-align: left;
    font-size: small;
    margin-left: 100px;
    margin-right:80px;
    margin-top: 30px;
  }
  .footerLast {
    font-size: small;
    margin-bottom: 0px;
    margin-top: -10px;
  }
  .mapInfo {
    padding-top: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .iconImage {
    vertical-align: middle;
    padding-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// LandingComponent.vue?635a3a1e